export const GST_LEDGER_REPORT_REQUEST = 'GST_LEDGER_REPORT_REQUEST';
export const GST_LEDGER_REPORT_SUCCESS = 'GST_LEDGER_REPORT_SUCCESS';
export const GST_LEDGER_REPORT_FAILURE = 'GST_LEDGER_REPORT_FAILURE';